import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { INPUT_TITLE_MAP } from '../inputs'

const propTypes = {
  /**
   * Input name
   */
  input: PropTypes.string.isRequired,
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Optional renderer for content displayed next to the input label
   */
  renderLabelAction: PropTypes.func,
  /**
   * If true, make the label (title) of item bold
   */
  labelBold: PropTypes.bool,
}

const defaultProps = {
  displayInput: () => true,
  renderLabelAction: () => null,
  labelBold: false,
}

function InputRow(props) {
  const { input, displayInput, renderInput, renderLabelAction, labelBold } = props

  if (!displayInput(input)) {
    return null
  }

  const messageId = INPUT_TITLE_MAP[input]
  const labelAction = renderLabelAction(input)

  return (
    <Row className="mb-3">
      <Col md="5" className={clsx('d-flex align-items-center', labelBold && 'text-bold')}>
        {messageId && (
          <span>
            <FormattedMessage id={messageId} />
          </span>
        )}
        {labelAction && <span className="ml-2 d-inline-flex align-items-center">{labelAction}</span>}
      </Col>
      <Col md="7">{renderInput(input)}</Col>
    </Row>
  )
}

InputRow.propTypes = propTypes
InputRow.defaultProps = defaultProps

export default InputRow
